import { render, staticRenderFns } from "./ProgramCanvas.vue?vue&type=template&id=c2a27ad8&scoped=true"
import script from "./ProgramCanvas.vue?vue&type=script&lang=js"
export * from "./ProgramCanvas.vue?vue&type=script&lang=js"
import style0 from "./ProgramCanvas.vue?vue&type=style&index=0&id=c2a27ad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a27ad8",
  null
  
)

export default component.exports